import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestSection() {
  const latestComics = getLatestComics(8);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">刚刚更新的韩国漫画章节</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            查看所有更新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}